(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-card-gallery"] && !Shopify.designMode) return;
  try {
    (function () {
    function isWishlistClick(event) {
      // composedPath() works even if the wishlist widget or card markup
      // lives inside a custom element / shadow root, where event.target
      // would otherwise be retargeted to the shadow host.
      var path = typeof event.composedPath === 'function' ? event.composedPath() : [];
      for (var i = 0; i < path.length; i++) {
        var node = path[i];
        if (node && node.classList && node.classList.contains('wishlist-engine')) {
          return true;
        }
      }
      return false;
    }

    // Bound once, directly on document, with no DOMContentLoaded gate -
    // this guarantees it's active for cards rendered later (filtering,
    // infinite scroll, section re-render, etc.) and isn't missed if
    // DOMContentLoaded already fired before this script executed.
    document.addEventListener('click', function (event) {
      if (isWishlistClick(event)) {
        event.preventDefault();
        event.stopPropagation();
      }
    });

    ['mousedown', 'pointerdown', 'touchstart'].forEach(function (eventName) {
      document.addEventListener(eventName, function (event) {
        if (isWishlistClick(event)) {
          event.stopPropagation();
        }
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
